/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AssetManager
 */
export interface AssetManager {
    /**
     * 
     * @type {string}
     * @memberof AssetManager
     */
    assetManagerName: string;
    /**
     * 
     * @type {string}
     * @memberof AssetManager
     */
    companyAbbreviation: string;
    /**
     * 
     * @type {number}
     * @memberof AssetManager
     */
    totalMarketValue: number;
    /**
     * 
     * @type {number}
     * @memberof AssetManager
     */
    percentageOfBook: number;
    /**
     * 
     * @type {string}
     * @memberof AssetManager
     */
    companyURL: string;
}

/**
 * Check if a given object implements the AssetManager interface.
 */
export function instanceOfAssetManager(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "assetManagerName" in value;
    isInstance = isInstance && "companyAbbreviation" in value;
    isInstance = isInstance && "totalMarketValue" in value;
    isInstance = isInstance && "percentageOfBook" in value;
    isInstance = isInstance && "companyURL" in value;

    return isInstance;
}

export function AssetManagerFromJSON(json: any): AssetManager {
    return AssetManagerFromJSONTyped(json, false);
}

export function AssetManagerFromJSONTyped(json: any, ignoreDiscriminator: boolean): AssetManager {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'assetManagerName': json['AssetManagerName'],
        'companyAbbreviation': json['companyAbbreviation'],
        'totalMarketValue': json['totalMarketValue'],
        'percentageOfBook': json['percentageOfBook'],
        'companyURL': json['companyURL'],
    };
}

export function AssetManagerToJSON(value?: AssetManager | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'AssetManagerName': value.assetManagerName,
        'companyAbbreviation': value.companyAbbreviation,
        'totalMarketValue': value.totalMarketValue,
        'percentageOfBook': value.percentageOfBook,
        'companyURL': value.companyURL,
    };
}

